import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';

import NeuriteGrid from '../../components/neurite_grid';

//actions:
import { openDialog, hideDialog, setSaveState } from '../../actions';
import { addContadorDeMaquina, removeContadorDeMaquina, modifyContadorDeMaquina } from '../../actions/maquina_contadores_actions';

const styles = theme => ({
    title: {
        margin: '5px 10px',
    },
    spinnerContainer: {
        width: '95%',
        height: 300,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    spinner: {
        width: '50px !important',
        height: '50px !important',
    },
});

class MaquinaContadores extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            dataGridScroll: false
        }
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.saveState && !this.props.saveState) {
            this.setState({ ...this.state, dataGridScroll: false });
        }
    }

    addContador = (contador) => {
        this.props.setSaveState(true);
        this.props.addContadorDeMaquina(contador);
        this.setState({ ...this.state, dataGridScroll: true });
    };

    modifyContadorMaquina = (contador) => {
        this.props.setSaveState(true);
        this.props.modifyContadorDeMaquina(contador);
    }

    messageDialog = (msg) => {

        this.props.openDialog('SimpleMessage', {
            message: msg
        }, uuidv4(), false, 'sm');

    };


    checkContador = (contador) => {
        if (isNaN(contador.iTipo)) {
            this.messageDialog('Por favor, rellene el campo i_tipo');
            return false;
        } else if (isNaN(contador.numOrden)) {
            this.messageDialog('Por favor, rellene el campo Num. Orden');
            return false;
        } else if (isNaN(contador.ultMultiplicador)) {
            this.messageDialog('Por favor, rellene el campo Ult. Multiplicador');
            return false;
        } else if (isNaN(contador.ultPrecio)) {
            this.messageDialog('Por favor, rellene el campo Ult. Precio');
            return false;
        }

        else return true;
    };

    newContador = () => {

        this.props.openDialog('EditContadorMaquina', {
            contador: {},
            maquinaId: this.props.id,
            okHandler: this.addContador,
            checkContador: this.checkContador,
            tipoB: this.props.tipoB
        }, uuidv4());

    };

    editContador = (contador) => {

        this.props.openDialog('EditContadorMaquina', {
            contador,
            okHandler: this.modifyContadorMaquina,
            checkContador: this.checkContador,
            maquinaId: this.props.id,
            tipoB: this.props.tipoB
        }, uuidv4());

    };

    removeContador = (contador, index) => {
        this.props.setSaveState(true);
        this.props.removeContadorDeMaquina(contador);
    };


    render() {

        const { classes } = this.props;

        return (
            <div >
                <Typography variant="h6" className={classes.title} color={'primary'}>Contadores</Typography>

                {this.props.maquinaContadores && !this.props.isLoading ?
                    <NeuriteGrid
                        id="m_c"
                        columns={this.props.tipoB ?
                            [
                                { key: 'tipoContador', name: 'Tipo Contador', editable: false, dragable: false, width: 100 },
                                { key: 'numOrden', name: 'Num. Orden', editable: false, dragable: false, width: 85 },
                                { key: 'ultMultiplicador', name: 'Ult. Multiplicador', editable: false, dragable: false, type: 'float', decimal: 3, width: 115 },
                                { key: 'ultPrecio', name: 'Ult. Precio', editable: false, dragable: false, type: 'float', decimal: 3, width: 75 },
                                { key: 'contadorCompra', name: 'Contador inicial', editable: false, dragable: false, type: 'int', width: 115 },
                                { key: 'contadorCompraSalidas', name: 'Contador inicial salidas', editable: false, dragable: false, type: 'int', width: 115 },
                                { key: 'activa', name: 'Activa', type: 'bool', editable: false, dragable: false, width: 55 },
                                { key: 'anulado', name: 'Anulado', type: 'bool', editable: false, dragable: false, width: 60 },
                                {
                                    key: 'launch', name: '', editable: false, dragable: false, type: 'launch', handleLaunchClick: (row) => {
                                        this.props.openDialog('EditLecturasContador', {
                                            id: row.id,
                                            tipoB: this.props.tipoB
                                        }, uuidv4(), false, 'md');
                                    }
                                },
                            ]
                            :
                            [
                                { key: 'tipoContador', name: 'Tipo Contador', editable: false, dragable: false, width: 100 },
                                { key: 'numOrden', name: 'Num. Orden', editable: false, dragable: false, width: 85 },
                                { key: 'ultMultiplicador', name: 'Ult. Multiplicador', editable: false, dragable: false, type: 'float', decimal: 3, width: 115 },
                                { key: 'ultPrecio', name: 'Ult. Precio', editable: false, dragable: false, type: 'float', decimal: 3, width: 75 },
                                { key: 'contadorCompra', name: 'Contador inicial', editable: false, dragable: false, type: 'int', width: 115 },
                                { key: 'activa', name: 'Activa', type: 'bool', editable: false, dragable: false, width: 55 },
                                { key: 'anulado', name: 'Anulado', type: 'bool', editable: false, dragable: false, width: 60 },
                                {
                                    key: 'launch', name: '', editable: false, dragable: false, type: 'launch', handleLaunchClick: (row) => {
                                        this.props.openDialog('EditLecturasContador', {
                                            id: row.id,
                                            tipoB: this.props.tipoB
                                        }, uuidv4(), false, 'md');
                                    }
                                },
                            ]
                        }
                        rows={this.props.maquinaContadores}
                        buttonEdit={true}
                        buttonDelete={true}
                        buttonNew={true}
                        onNewRowClick={this.newContador}
                        onEditClick={this.editContador}
                        onDeleteClick={this.removeContador}
                        last={this.state.dataGridScroll}
                        height={200}
                    />
                    : <div className={classes.spinnerContainer}> <CircularProgress className={classes.spinner} color="primary" /> </div>}
            </div>
        );

    };

};

MaquinaContadores.propTypes = {
    //state
    isLoading: PropTypes.bool.isRequired,
    maquinaContadores: PropTypes.array.isRequired,
    //dispatch
    openDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
    addContadorDeMaquina: PropTypes.func.isRequired,
    removeContadorDeMaquina: PropTypes.func.isRequired,
    modifyContadorDeMaquina: PropTypes.func.isRequired,
    //props:
    id: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        maquinaContadores: state.maquinaContadores.maquinaContadores,
        tipoB: state.maquinaDetalle.maquinadetalles.tipoB,
        isLoading: state.maquinaContadores.isLoading,
        saveState: state.saveState
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        openDialog,
        hideDialog,
        addContadorDeMaquina,
        removeContadorDeMaquina,
        modifyContadorDeMaquina,
        setSaveState
    }, dispatch);
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(MaquinaContadores));